import { hasNextPage } from '../../redux-jigsaw/page-context-selectors';

export function isReadAloudOpen(state) {
  return state.ui.kiddie.isReadAloudOpen;
}

export function isBookCompleteShowing(state) {
  return state.ui.kiddie.isBookCompleteShowing;
}

export function hasNextPageKiddie(state) {
  const jigaswVal = hasNextPage(state);
  if (typeof jigaswVal === 'boolean') {
    return !isBookCompleteShowing(state);
  }
  return false;
}

export function areToolsCollapsed(state) {
  return state.ui.kiddie.areToolsCollapsed;
}
